import { useTranslation } from "react-i18next";
import { builderStreamSample } from "../../lib/metadata-builder/sample-schedule";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { StreamSlotForm } from "../schedule/StreamSlotForm";
import { CommonOptionsForm } from "../schedule/CommonOptionsSection";

type BuilderStreamInputsProps = { twoStreams: boolean };

export function BuilderStreamInputs({ twoStreams }: BuilderStreamInputsProps) {
  const { t } = useTranslation();
  const slots = useMetadataBuilderStore(state => state.sampleSlots);
  const options = useMetadataBuilderStore(state => state.sampleCommonOptions);
  const setSlot = useMetadataBuilderStore(state => state.setSampleSlot);
  const resetSlot = useMetadataBuilderStore(state => state.resetSampleSlot);
  const setOptions = useMetadataBuilderStore(state => state.setSampleCommonOptions);
  const numbers = twoStreams ? [1, 2] as const : [1] as const;
  return <section className="space-y-2 rounded border border-neutral-200 p-2" onFocusCapture={endMetadataMerge}>
    <h4 className="text-xs font-semibold">{t("builder.inputs.title")}</h4>
    <p className="text-neutral-500">{t("builder.inputs.streamHelp")}</p>
    {numbers.map(number => <StreamSlotForm key={number} slot={builderStreamSample(number, slots[number])}
      number={number} day={t("builder.inputs.title")} memberOnlyLabel={options.memberOnlyLabel ?? t("schedule.memberOnly")}
      lockActive onChange={patch => setSlot(number, patch)} onReset={() => resetSlot(number)} onBlur={endMetadataMerge} />)}
    <CommonOptionsForm memberOnlyLabel={options.memberOnlyLabel} onChange={memberOnlyLabel => setOptions({ memberOnlyLabel })} onBlur={endMetadataMerge} />
  </section>;
}
